import React from 'react'
import { ListItem } from '../listItem'
import styled from '@emotion/styled'
import { Link, useHistory } from 'react-router-dom'
import { Tooltip } from '@organice/atoms'

export interface DocumentTemplateListEntryData {
  id: bigint
  name: string
}

export interface DocumentTemplateListEntryProps {
  data: DocumentTemplateListEntryData
  getLink?(id: string): string
}

export const DocumentTemplateListEntry: React.FC<DocumentTemplateListEntryProps> =
  React.memo(
    ({
      data,
      getLink = (id: string) => `/configuration/document-template/${id}`,
    }) => {
      const history = useHistory()

      const nameLength = data.name.length
      const toolTipFrom = 30
      const addToolTip = nameLength > toolTipFrom

      const documentTemplateLink = getLink(String(data.id))

      return (
        <BorderlessListItem
          onClick={e => {
            if (e.ctrlKey || e.metaKey) {
              return
            }
            history.replace(documentTemplateLink)
          }}
        >
          {addToolTip ? (
            <Tooltip placement="top" title={data.name}>
              <ListItemText to={documentTemplateLink}>{data.name}</ListItemText>
            </Tooltip>
          ) : (
            <ListItemText to={documentTemplateLink}>{data.name}</ListItemText>
          )}
        </BorderlessListItem>
      )
    },
    (prevProps, nextProps) =>
      prevProps.data.id === nextProps.data.id &&
      prevProps.data.name === nextProps.data.name
  )

const BorderlessListItem = styled(ListItem)(({ theme }) => ({
  '&&&': {
    border: 0,
    cursor: 'pointer',
    lineHeight: '1.467',
    padding: 0,
    '&:hover': {
      backgroundColor: theme.lightBackground,
      borderRadius: theme.borderRadiusBase,
      '& > div': {
        visibility: 'visible',
      },
    },
    '& > div': {
      visibility: 'hidden',
    },
  },
}))

const ListItemText = styled(Link)({
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis',
  overflow: 'hidden',
  paddingRight: '0.625rem',
  fontSize: '15px',
  fontWeight: 500,
  width: '100%',
  padding: '0.3125rem 0.625rem',
})
